import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';
import CookieBanner from '../../components/feature/CookieBanner';

export default function ServiciosPage() {
  const services = [
    {
      icon: 'ri-brush-line',
      title: 'Limpieza de Hollín en Superficies',
      description: 'El hollín es uno de los residuos más difíciles de eliminar tras un incendio. Nuestro servicio especializado de limpieza de hollín en Hospitalet de Llobregat utiliza técnicas profesionales y productos específicos para eliminar completamente estos residuos de paredes, techos, suelos y cualquier superficie afectada.',
      benefits: [
        'Eliminación completa de residuos de hollín y humo',
        'Técnicas especializadas para cada tipo de superficie',
        'Productos profesionales que no dañan los materiales',
        'Restauración del aspecto original de paredes y techos',
        'Prevención de manchas permanentes',
        'Limpieza profunda de rincones y zonas difíciles'
      ],
      image: 'https://public.readdy.ai/ai/img_res/781294eae5c113d9b022b072fe2023aa.jpg'
    },
    {
      icon: 'ri-windy-line',
      title: 'Eliminación de Malos Olores',
      description: 'Los olores persistentes tras un incendio pueden permanecer durante meses si no se tratan adecuadamente. En RESTAURAX somos expertos en eliminación de malos olores en Barcelona, utilizando técnicas avanzadas que neutralizan completamente los olores a humo y quemado.',
      benefits: [
        'Eliminación total de olores a humo y quemado',
        'Tratamientos específicos según el tipo de incendio',
        'Neutralización de olores en textiles y tapicerías',
        'Purificación del aire interior',
        'Resultados duraderos y permanentes',
        'Ambiente completamente renovado y respirable'
      ],
      image: 'https://readdy.ai/api/search-image?query=Air%20purification%20system%20working%20in%20fire%20damaged%20room%2C%20professional%20odor%20elimination%20equipment%20with%20visible%20air%20flow%2C%20modern%20restoration%20technology%2C%20clean%20bright%20atmosphere%20showing%20air%20quality%20improvement%2C%20professional%20indoor%20environment%20restoration&width=600&height=400&seq=service-olores-002&orientation=landscape'
    },
    {
      icon: 'ri-delete-bin-line',
      title: 'Desescombro y Vaciado',
      description: 'El desescombro es el primer paso fundamental en cualquier proceso de restauración post incendio. Nuestro equipo en Hospitalet de Llobregat se encarga de retirar de forma segura y eficiente todos los escombros, muebles dañados y materiales afectados por el fuego.',
      benefits: [
        'Retirada rápida y segura de escombros',
        'Clasificación y separación de materiales recuperables',
        'Vaciado completo de espacios afectados',
        'Gestión legal de residuos peligrosos',
        'Transporte y eliminación ecológica de escombros',
        'Preparación del espacio para la restauración'
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20team%20removing%20fire%20debris%20and%20damaged%20materials%20from%20building%20interior%2C%20workers%20in%20safety%20gear%20loading%20debris%20into%20truck%2C%20organized%20demolition%20and%20cleanup%20work%2C%20professional%20waste%20management%2C%20bright%20daylight%20showing%20efficient%20work%20process&width=600&height=400&seq=service-desescombro-003&orientation=landscape'
    },
    {
      icon: 'ri-contrast-drop-line',
      title: 'Tratamiento de Ozono',
      description: 'El tratamiento de ozono es una de las técnicas más efectivas para la desinfección y purificación tras un incendio. En RESTAURAX utilizamos generadores de ozono profesionales que eliminan bacterias, virus y neutralizan olores de forma definitiva en toda el área de Barcelona.',
      benefits: [
        'Desinfección profunda y completa del espacio',
        'Eliminación de bacterias, virus y hongos',
        'Neutralización definitiva de olores persistentes',
        'Tratamiento ecológico sin productos químicos',
        'Purificación del aire y superficies',
        'Seguro para personas y mascotas tras el tratamiento'
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20ozone%20treatment%20machine%20working%20in%20empty%20room%20after%20fire%20damage%2C%20modern%20ozone%20generator%20equipment%20with%20visible%20mist%2C%20high-tech%20restoration%20technology%2C%20clean%20professional%20environment%20showing%20air%20purification%20process%2C%20safety%20equipment%20visible&width=600&height=400&seq=service-ozono-004&orientation=landscape'
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Pintura Final',
      description: 'La pintura final es el toque que devuelve el aspecto original a tu espacio tras un incendio. Nuestros pintores profesionales en Hospitalet de Llobregat utilizan pinturas de alta calidad y técnicas especializadas para garantizar un acabado perfecto y duradero.',
      benefits: [
        'Pinturas de alta calidad resistentes y duraderas',
        'Preparación profesional de superficies',
        'Acabados perfectos sin imperfecciones',
        'Amplia gama de colores y acabados',
        'Aplicación de imprimaciones especiales anti-hollín',
        'Garantía de durabilidad y resistencia'
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20painter%20applying%20fresh%20white%20paint%20to%20restored%20wall%20after%20fire%20damage%2C%20smooth%20painting%20technique%20visible%2C%20high%20quality%20finish%2C%20bright%20clean%20renovated%20interior%2C%20professional%20painting%20equipment%2C%20perfect%20wall%20surface%20showing%20restoration%20quality&width=600&height=400&seq=service-pintura-005&orientation=landscape'
    },
    {
      icon: 'ri-tools-line',
      title: 'Pequeñas Reparaciones',
      description: 'Los incendios a menudo causan daños estructurales menores que requieren reparación. Nuestro servicio de pequeñas reparaciones en Barcelona incluye trabajos de albañilería, carpintería, fontanería y electricidad para dejar tu espacio completamente restaurado.',
      benefits: [
        'Reparación de daños en paredes y techos',
        'Trabajos de carpintería y cerrajería',
        'Reparaciones eléctricas básicas',
        'Arreglos de fontanería si es necesario',
        'Sustitución de elementos dañados',
        'Restauración completa del espacio'
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20handyman%20repairing%20fire%20damaged%20wall%20and%20ceiling%2C%20construction%20tools%20visible%2C%20detailed%20repair%20work%20in%20progress%2C%20professional%20restoration%20craftsmanship%2C%20bright%20lighting%20showing%20quality%20repair%20work%2C%20safety%20equipment%20and%20materials%20visible&width=600&height=400&seq=service-reparaciones-006&orientation=landscape'
    }
  ];

  return (
    <>
      <div className="min-h-screen flex flex-col">
        <Header />

        {/* Hero */}
        <section className="bg-gradient-to-br from-[#544E13] to-[#3a3610] text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Servicios</h1>
            <p className="text-xl text-gray-200 max-w-3xl">
              Servicios profesionales de limpieza y restauración post incendio en Hospitalet de Llobregat y Barcelona. Soluciones integrales para la recuperación completa de tu espacio.
            </p>
          </div>
        </section>

        {/* Introducción */}
        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-[#544E13] mb-6">Servicios completos de limpieza post incendio en Barcelona</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              En <strong>RESTAURAX</strong> ofrecemos un servicio integral de <strong>limpieza y restauración post incendio en Hospitalet de Llobregat</strong> y toda el área metropolitana de Barcelona. Nuestro equipo de profesionales certificados está preparado para afrontar cualquier situación, desde pequeños incendios domésticos hasta grandes siniestros en locales comerciales o naves industriales. Conoce más sobre <Link to="/empresa" className="text-[#F2D70A] hover:text-[#544E13] font-semibold underline">nuestra empresa y experiencia</Link>.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Cada incendio es único y requiere un enfoque personalizado. Por eso, antes de comenzar cualquier trabajo, realizamos una evaluación exhaustiva de los daños para diseñar un plan de actuación específico que garantice los mejores resultados. Nuestros servicios abarcan desde la <strong>limpieza de hollín</strong> y la <strong>eliminación de olores</strong> hasta el <strong>desescombro</strong>, el <strong>tratamiento de ozono</strong>, la <strong>pintura final</strong> y las <strong>pequeñas reparaciones</strong> necesarias.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Trabajamos con las técnicas más avanzadas y los equipos más modernos del sector para asegurar que tu hogar o negocio en Barcelona recupere su estado original en el menor tiempo posible. Además, coordinamos directamente con las compañías de seguros para facilitar todo el proceso administrativo y minimizar las preocupaciones de nuestros clientes. Si tienes dudas sobre nuestros procesos, consulta nuestras <Link to="/faq" className="text-[#F2D70A] hover:text-[#544E13] font-semibold underline">preguntas frecuentes</Link> o <Link to="/contacto" className="text-[#F2D70A] hover:text-[#544E13] font-semibold underline">contáctanos directamente</Link>.
            </p>
          </div>
        </section>

        {/* Servicios Detallados */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="space-y-16" data-product-shop>
              {services.map((service, index) => (
                <div key={index} className={`grid md:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'md:flex-row-reverse' : ''}`}>
                  <div className={index % 2 === 1 ? 'md:order-2' : ''}>
                    <div className="w-16 h-16 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-6">
                      <i className={`${service.icon} text-3xl text-[#544E13]`}></i>
                    </div>
                    <h3 className="text-2xl md:text-3xl font-bold text-[#544E13] mb-4">
                      {service.title}
                    </h3>
                    <p className="text-gray-700 leading-relaxed mb-6">
                      {service.description}
                    </p>
                    <h4 className="text-lg font-bold text-[#544E13] mb-3">Beneficios de este servicio:</h4>
                    <ul className="space-y-2 mb-6">
                      {service.benefits.map((benefit, idx) => (
                        <li key={idx} className="flex items-start space-x-3">
                          <i className="ri-checkbox-circle-fill text-[#F2D70A] text-xl flex-shrink-0 mt-0.5"></i>
                          <span className="text-gray-700">{benefit}</span>
                        </li>
                      ))}
                    </ul>
                    <Link 
                      to="/contacto"
                      className="inline-block bg-[#F2D70A] text-[#544E13] px-6 py-3 rounded-lg font-semibold hover:bg-[#544E13] hover:text-white transition-all whitespace-nowrap cursor-pointer"
                    >
                      Solicitar este Servicio
                    </Link>
                  </div>
                  <div className={index % 2 === 1 ? 'md:order-1' : ''}>
                    <img 
                      src={service.image}
                      alt={service.title}
                      className="rounded-lg shadow-xl w-full h-auto object-cover object-top"
                      title={`${service.title} - RESTAURAX Barcelona`}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Proceso de Trabajo */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl md:text-4xl font-bold text-[#544E13] mb-6 text-center">
              Nuestro proceso de trabajo paso a paso
            </h2>
            <p className="text-xl text-gray-600 text-center mb-12 max-w-3xl mx-auto">
              Seguimos un protocolo riguroso y profesional en cada intervención de <strong>restauración post incendio</strong> en Hospitalet de Llobregat y Barcelona.
            </p>

            <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
              <div className="bg-gray-50 rounded-lg p-6 border-2 border-[#F2D70A]">
                <div className="w-12 h-12 bg-[#F2D70A] rounded-full flex items-center justify-center mb-4">
                  <span className="text-xl font-bold text-[#544E13]">1</span>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">1. Evaluación inicial</h3>
                <p className="text-gray-600 text-sm">
                  Contacto inmediato 24/7. Atendemos tu llamada y nos desplazamos rápidamente a Hospitalet de Llobregat o Barcelona.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6 border-2 border-[#F2D70A]">
                <div className="w-12 h-12 bg-[#F2D70A] rounded-full flex items-center justify-center mb-4">
                  <span className="text-xl font-bold text-[#544E13]">2</span>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">2. Planificación detallada</h3>
                <p className="text-gray-600 text-sm">
                  Inspección detallada de los daños, documentación fotográfica y elaboración de presupuesto detallado.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6 border-2 border-[#F2D70A]">
                <div className="w-12 h-12 bg-[#F2D70A] rounded-full flex items-center justify-center mb-4">
                  <span className="text-xl font-bold text-[#544E13]">3</span>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">3. Desescombro y limpieza inicial</h3>
                <p className="text-gray-600 text-sm">
                  Retirada de escombros, limpieza profunda de hollín y eliminación de materiales dañados.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6 border-2 border-[#F2D70A]">
                <div className="w-12 h-12 bg-[#F2D70A] rounded-full flex items-center justify-center mb-4">
                  <span className="text-xl font-bold text-[#544E13]">4</span>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">4. Limpieza especializada</h3>
                <p className="text-gray-600 text-sm">
                  Aplicación de tratamiento de ozono, eliminación de olores y desinfección completa del espacio.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6 border-2 border-[#F2D70A]">
                <div className="w-12 h-12 bg-[#F2D70A] rounded-full flex items-center justify-center mb-4">
                  <span className="text-xl font-bold text-[#544E13]">5</span>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">5. Tratamiento de ozono</h3>
                <p className="text-gray-600 text-sm">
                  Aplicación de tratamiento de ozono, eliminación de olores y desinfección completa del espacio.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6 border-2 border-[#F2D70A]">
                <div className="w-12 h-12 bg-[#F2D70A] rounded-full flex items-center justify-center mb-4">
                  <span className="text-xl font-bold text-[#544E13]">6</span>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">6. Acabados finales</h3>
                <p className="text-gray-600 text-sm">
                  Pintura, pequeñas reparaciones y acabados finales para devolver el espacio a su estado original.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Ventajas Competitivas */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl md:text-4xl font-bold text-[#544E13] mb-12 text-center">
              Por qué elegir RESTAURAX en Hospitalet de Llobregat
            </h2>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white rounded-lg p-8 shadow-lg">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-time-line text-3xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Experiencia comprobada</h3>
                <p className="text-gray-600 leading-relaxed">
                  Servicio de emergencia 24/7 en Hospitalet de Llobregat y Barcelona. Actuamos de inmediato para minimizar los daños causados por el incendio y el humo. <Link to="/contacto" className="text-[#F2D70A] hover:text-[#544E13] font-semibold">Contáctanos ahora</Link>.
                </p>
              </div>

              <div className="bg-white rounded-lg p-8 shadow-lg">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-tools-fill text-3xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Tecnología avanzada</h3>
                <p className="text-gray-600 leading-relaxed">
                  Utilizamos maquinaria y productos de última generación para la <strong>limpieza de hollín</strong>, <strong>tratamiento de ozono</strong> y <strong>eliminación de olores</strong>.
                </p>
              </div>

              <div className="bg-white rounded-lg p-8 shadow-lg">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-team-line text-3xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Equipo certificado</h3>
                <p className="text-gray-600 leading-relaxed">
                  Profesionales certificados con más de 15 años de experiencia en <strong>restauración post incendio</strong> en Barcelona y alrededores. <Link to="/empresa" className="text-[#F2D70A] hover:text-[#544E13] font-semibold">Conoce nuestro equipo</Link>.
                </p>
              </div>

              <div className="bg-white rounded-lg p-8 shadow-lg">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-file-shield-line text-3xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Disponibilidad 24/7</h3>
                <p className="text-gray-600 leading-relaxed">
                  Tramitamos directamente con tu compañía de seguros, facilitando todo el proceso administrativo y documental necesario.
                </p>
              </div>

              <div className="bg-white rounded-lg p-8 shadow-lg">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-price-tag-3-line text-3xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Presupuestos transparentes</h3>
                <p className="text-gray-600 leading-relaxed">
                  Presupuestos detallados y sin sorpresas. Sabrás exactamente qué incluye cada servicio de <strong>limpieza post incendio</strong> y su coste. <Link to="/faq" className="text-[#F2D70A] hover:text-[#544E13] font-semibold">Ver preguntas frecuentes</Link>.
                </p>
              </div>

              <div className="bg-white rounded-lg p-8 shadow-lg">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-checkbox-circle-line text-3xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Garantía de satisfacción</h3>
                <p className="text-gray-600 leading-relaxed">
                  Garantizamos la calidad de todos nuestros trabajos de restauración. Si no quedas satisfecho, repetimos el servicio sin coste adicional.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Tipos de Espacios */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl md:text-4xl font-bold text-[#544E13] mb-12 text-center">
              Tipos de espacios que restauramos
            </h2>
            <p className="text-xl text-gray-600 text-center mb-12 max-w-3xl mx-auto">
              Ofrecemos nuestros servicios de <strong>limpieza y restauración post incendio</strong> para cualquier tipo de propiedad en Hospitalet de Llobregat y alrededores.
            </p>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-gray-50 rounded-lg p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-home-4-line text-2xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Viviendas particulares</h3>
                <p className="text-gray-600 text-sm">
                  Pisos, casas y chalets afectados por incendios domésticos.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-store-2-line text-2xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Locales comerciales</h3>
                <p className="text-gray-600 text-sm">
                  Tiendas, restaurantes y negocios en Barcelona.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-building-line text-2xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Oficinas y despachos</h3>
                <p className="text-gray-600 text-sm">
                  Espacios de trabajo y edificios corporativos.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-community-line text-2xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Naves industriales</h3>
                <p className="text-gray-600 text-sm">
                  Almacenes, fábricas y espacios industriales.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-government-line text-2xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Edificios públicos</h3>
                <p className="text-gray-600 text-sm">
                  Escuelas, centros de salud y otros espacios públicos.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-community-line text-2xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Comunidades de vecinos</h3>
                <p className="text-gray-600 text-sm">
                  Bloques de viviendas y edificios conjuntos.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Presupuestos */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl md:text-4xl font-bold text-[#544E13] mb-12 text-center">
              Presupuestos transparentes y sin sorpresas
            </h2>

            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
              <h3 className="text-2xl font-bold text-[#544E13] mb-4">
                Solicita tu presupuesto gratuito
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                Completa el formulario y recibe un presupuesto gratuito y sin compromiso. Nuestro equipo experto evaluará tu caso y te proporcionará una solución personalizada.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link 
                  to="/contacto"
                  className="bg-[#F2D70A] text-[#544E13] px-8 py-4 rounded-lg font-bold text-lg hover:bg-white transition-all whitespace-nowrap cursor-pointer"
                >
                  Solicitar Presupuesto Gratis
                </Link>
                <a 
                  href="tel:690220944"
                  className="bg-white/10 backdrop-blur-sm text-white border-2 border-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white hover:text-[#544E13] transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line mr-2"></i>
                  690 22 09 44
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 bg-gradient-to-br from-[#544E13] to-[#3a3610] text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Confía en los expertos en restauración post incendio
            </h2>
            <p className="text-xl mb-8 text-gray-200">
              Contacta con RESTAURAX ahora y recibe un presupuesto gratuito y sin compromiso. Estamos disponibles 24/7 para atender tu emergencia en Hospitalet de Llobregat y Barcelona.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/contacto"
                className="bg-[#F2D70A] text-[#544E13] px-8 py-4 rounded-lg font-bold text-lg hover:bg-white transition-all whitespace-nowrap cursor-pointer"
              >
                Solicitar Presupuesto Gratis
              </Link>
              <a 
                href="tel:690220944"
                className="bg-white/10 backdrop-blur-sm text-white border-2 border-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white hover:text-[#544E13] transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                690 22 09 44
              </a>
            </div>
          </div>
        </section>

        <Footer />
        <WhatsAppButton />
        <ScrollToTopButton />
      </div>
    </>
  );
}